import { isNativeApp, isBundledNativeOrigin } from './appOrigin';

/**
 * The packaged app's pre-login screen. Not a route on any website build — see
 * pages/welcome.vue for why it is nonetheless a normal page.
 */
export const APP_WELCOME_PATH = '/welcome';

/**
 * Where an unauthenticated visitor to an /lms route is sent.
 *
 * On the web this is unchanged: straight to /login/[portal], which immediately calls
 * `loginWithRedirect()` and bounces to Auth0. A website visitor arrived by clicking a
 * link, so they already have context for why a login page appeared.
 *
 * Someone who has just tapped an app icon has no such context. Sending them straight
 * out to Auth0's hosted page means the first thing the app ever shows is a spinner
 * followed by a browser — no branding, no explanation, and nothing at all if the
 * device is offline. The packaged app therefore gets a welcome screen first, and
 * reaches the identical /login/[portal] route from a button on it.
 *
 * Gated on the *bundled* origin, not merely on running inside Capacitor, for the same
 * reason `resolveAuthRedirectUri` is: the Phase 0 diagnostic build injects the
 * Capacitor bridge into a WebView pointed at the real website, where the welcome
 * screen is neither wanted nor present in the deployed assets. See functions/appOrigin.ts.
 */
export function resolveLoginEntryPath(portal: string): string {
   if (isNativeApp() && isBundledNativeOrigin()) return APP_WELCOME_PATH;

   return `/login/${portal}`;
}
